import { render, staticRenderFns } from "./OrderHistoryDialog.vue?vue&type=template&id=237c5adb&scoped=true&"
import script from "./OrderHistoryDialog.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryDialog.vue?vue&type=style&index=0&id=237c5adb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237c5adb",
  null
  
)

export default component.exports